var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"amount-format",class:[{ 'pr-3': _vm.amountDecimal }, _vm.formatClass]},[_c('span',{staticClass:"amount-integer"},[_vm._v(_vm._s(_vm.amountInt))]),_c('span',{staticClass:"amount-decimal-top pr-3"},[_vm._v(_vm._s(_vm.amountDecimal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }